// extracted by mini-css-extract-plugin
export default {"external":"aIX10p","iconWrapper":"bIX10p"};